/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Heading_TaglineInputs */

const en_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`thoughts & writings`)
};

const ar_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفكار وكتابات`)
};

const bn_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভাবনা আর লেখা`)
};

const de_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedanken & Texte`)
};

const es_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ideas y escritos`)
};

const fr_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pensées et écrits`)
};

const pt_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ideias e escritos`)
};

const zh_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想法和著作`)
};

const tr_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`düşünceler ve yazılar`)
};

const ru_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мысли и сочинения`)
};

const pl_notes_heading_tagline = /** @type {(inputs: Notes_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`przemyślenia i pisma`)
};

/**
* | output |
* | --- |
* | "thoughts & writings" |
*
* @param {Notes_Heading_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const notes_heading_tagline = /** @type {((inputs?: Notes_Heading_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Heading_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_notes_heading_tagline(inputs)
	if (locale === "bn") return bn_notes_heading_tagline(inputs)
	if (locale === "de") return de_notes_heading_tagline(inputs)
	if (locale === "es") return es_notes_heading_tagline(inputs)
	if (locale === "fr") return fr_notes_heading_tagline(inputs)
	if (locale === "pt") return pt_notes_heading_tagline(inputs)
	if (locale === "zh") return zh_notes_heading_tagline(inputs)
	if (locale === "tr") return tr_notes_heading_tagline(inputs)
	if (locale === "ru") return ru_notes_heading_tagline(inputs)
	if (locale === "pl") return pl_notes_heading_tagline(inputs)
	return en_notes_heading_tagline(inputs)
});